<template>
    <div class="main-section">
        <keep-alive>
            <component
                :is="CURRENT_COMPONENT"
                :id="contact.id.toString()"
                data-qa="component"
                :contact="contact"
                :tab-name="tabName"
                :user-id="metaData.userId.toString()"
                :app-id="metaData.appId.toString()"
                :back-url="metaData.backUrl.toString()"
                :tab-id="tabId"
                :layout-id="selectedLayoutId"
            />
        </keep-alive>
    </div>
</template>

<script>
import axios from 'axios';
import ContactInfo from './ContactInfo';
import ContactTags from './ContactTags';
import ContactMoney from './ContactMoney';
import ContactTasks from './ContactTasks';
import ContactNotes from './ContactNotes';
import ContactTabUnderConstruction from './ContactTabUnderConstruction';
import ContactCustomFields from './ContactCustomFields';
import CustomFields from './CustomFields';
import CustomLayoutContactRecord from './layout/CustomLayoutContactRecord';
import ScoredActivities from './ScoredActivities';
import ContactForms from './ContactForms';
import ContactOpportunities from './ContactOpportunities';
import ContactEmails from './ContactEmails.vue';
import ContactFiles from './ContactFiles.vue';
import LinkedContacts from './LinkedContacts';
import ContactCampaignsStealth from './ContactCampaignStealth.vue';
import ContactReferralPartner from './ContactReferralPartner';
import ContactAppointments from './ContactAppointments';
import ContactAccessPrivileges from './ContactAccessPrivileges';
import ContactCampaigns from './ContactCampaigns';
import ContactFollowUpSequences from './ContactFollowUpSequences.vue';
import ContactWebProfile from './ContactWebProfile.vue';

export default {
    components: {
        ContactMoney,
        ContactTasks,
        ContactTags,
        ContactInfo,
        ContactNotes,
        ContactTabUnderConstruction,
        ContactCustomFields,
        CustomLayoutContactRecord,
        CustomFields,
        ScoredActivities,
        ContactForms,
        ContactOpportunities,
        ContactEmails,
        ContactFiles,
        LinkedContacts,
        ContactCampaignsStealth,
        ContactReferralPartner,
        ContactAppointments,
        ContactAccessPrivileges,
        ContactCampaigns,
        ContactFollowUpSequences,
        ContactWebProfile,
    },

    props: {
        contact: Object,
        metaData: Object,
    },

    data() {
        return {
            url: '/app/contact',
            selectedTab: '',
            layoutId: 0,
            CURRENT_COMPONENT: 'ContactInfo',
            tabName: '',
            tabComponentName: '',
            isUnderConstruction: false,
            tabId: 0,

            contactPermissionDTO: {
                canChangeLeadSource: false,
                canDelete: false,
                canReassign: false,
                canUseActivityHistoryTemplates: false,
                canSeeOtherUsers: false,
                canEditAllRecords: false,
                canSeeSummary: false,
            },
            selectedLayoutId: 0,
            originalTabList: ['Notes', 'Tags', 'Money', 'Tasks', 'Appointments', 'Form submissions', 'Emails', 'Campaigns', 'Opportunities', 'Scored activities', 'Files', 'Linked contacts', 'Follow-up-sequences', 'Web profile', 'Access privileges', 'Referral partner', 'Campaigns stealth'],
            copyEverythingTabList: ['Contact Info', 'Custom fields', 'Notes', 'Tags', 'Money', 'Tasks', 'Form submissions', 'Scored activity', 'Files', 'Linked contacts', 'Follow-up sequences', 'Web profile', 'Access privileges', 'Referral partner', 'Campaigns stealth'],
        };
    },

    created() {
        this.fetchDropdowns();
        this.getContactPermissions();
        this.getAllComponents();
        this.$root.$on('TAB_SELECTED', (tabName) => {
            this.tabName = tabName;

            this.fetchDropdowns();
            this.getContactPermissions();
            this.CURRENT_COMPONENT = this.renderComponent(tabName);
        });
        this.$root.$emit('DROPDOWN_LOADED', this.options);

        this.selectedLayoutId = Number(this.metaData.defaultLayoutId);
    },

    mounted() {
        this.$root.$on('LAYOUTID_TAB', (data) => {
            this.selectedLayoutId = Number(data.id);
        });
    },

    methods: {
        getAllComponents() {
            this.tabComponentName = new Map();

            this.tabComponentName.set('ContactInfo', 'ContactInfo');
            this.tabComponentName.set('ContactNotes', 'ContactNotes');
            this.tabComponentName.set('ContactTags', 'ContactTags');
            this.tabComponentName.set('ContactTasks', 'ContactTasks');
            this.tabComponentName.set('ContactMoney', 'ContactMoney');
            this.tabComponentName.set('ScoredActivities', 'ScoredActivities');
            this.tabComponentName.set('ContactOpportunities', 'ContactOpportunities');
            this.tabComponentName.set('ContactEmails', 'ContactEmails');
            this.tabComponentName.set('ContactFiles', 'ContactFiles');
            this.tabComponentName.set('LinkedContacts', 'LinkedContacts');
            this.tabComponentName.set('ContactCampaignsStealth', 'ContactCampaignsStealth');
            this.tabComponentName.set('ContactReferralPartner', 'ContactReferralPartner');
            this.tabComponentName.set('ContactAccessPrivileges', 'ContactAccessPrivileges');
            this.tabComponentName.set('ContactCampaigns', 'ContactCampaigns');
            this.tabComponentName.set('ContactFollowUpSequences', 'ContactFollowUpSequences');
            this.tabComponentName.set('ContactWebProfile', 'ContactWebProfile');

            if (this.selectedLayoutId === 0 && this.metaData.isFeatureFlag33491Enabled) {
                this.tabComponentName.set('CustomFields', 'CustomFields');
            }
            this.tabComponentName.set('ContactForms', 'ContactForms');
            this.tabComponentName.set('ContactAppointments', 'ContactAppointments');
        },

        renderComponent(tabName) {
            let tab;

            if (this.tabComponentName.has(tabName)) {
                tab = tabName;

                if (tabName.toString() === 'CustomFields') {
                    this.$root.$emit('DISABLE_SAVE_BUTTON', true);
                }
            } else if (tabName.startsWith('customFlds')) {
                const cstData = tabName.split('customFlds_');
                const customData = cstData[1].split('tbNme_tbsId');

                this.tabName = customData[0].toString();
                this.tabId = Number(customData[1]);

                this.$root.$emit('CUSTOM_DATA', this.tabId);
                this.$root.$emit('CUSTOM_DATA_LOADED', true);

                tab = 'ContactCustomFields';
            } else if (tabName.includes('from_Layout_$')) {
                const layoutTabName = tabName.split('from_Layout_$');

                if (this.originalTabList.includes(layoutTabName[1]) || this.copyEverythingTabList.includes(layoutTabName[1])) {
                    if (layoutTabName[1].toString() === 'Contact Info') {
                        this.$root.$emit('DISABLE_SAVE_BUTTON', true);
                        layoutTabName[1] = 'ContactInfo';
                    } else if (layoutTabName[1].toString() === 'Notes') {
                        layoutTabName[1] = 'ContactNotes';
                        this.$root.$emit('DISABLE_SAVE_BUTTON', false);
                    } else if (layoutTabName[1].toString() === 'Tags') {
                        layoutTabName[1] = 'ContactTags';
                        this.$root.$emit('DISABLE_SAVE_BUTTON', false);
                    } else if (layoutTabName[1].toString() === 'Money') {
                        layoutTabName[1] = 'ContactMoney';
                        this.$root.$emit('DISABLE_SAVE_BUTTON', false);
                    } else if (layoutTabName[1].toString() === 'Tasks') {
                        layoutTabName[1] = 'ContactTasks';
                        this.$root.$emit('DISABLE_SAVE_BUTTON', false);
                    } else if (layoutTabName[1].toString() === 'Scored activity') {
                        layoutTabName[1] = 'ScoredActivities';
                    } else if (layoutTabName[1].toString() === 'Appointments') {
                        layoutTabName[1] = 'ContactAppointments';
                        this.$root.$emit('DISABLE_SAVE_BUTTON', false);
                    } else if (layoutTabName[1].toString() === 'Form submissions') {
                        layoutTabName[1] = 'ContactForms';
                        this.$root.$emit('DISABLE_SAVE_BUTTON', false);
                    } else if (layoutTabName[1].toString() === 'Opportunities') {
                        layoutTabName[1] = 'ContactOpportunities';
                    } else if (layoutTabName[1].toString() === 'Emails') {
                        this.$root.$emit('DISABLE_SAVE_BUTTON', false);
                        layoutTabName[1] = 'ContactEmails';
                    } else if (layoutTabName[1].toString() === 'Files') {
                        this.$root.$emit('DISABLE_SAVE_BUTTON', false);
                        layoutTabName[1] = 'ContactFiles';
                    } else if (layoutTabName[1].toString() === 'Linked contacts') {
                        this.$root.$emit('DISABLE_SAVE_BUTTON', false);
                        layoutTabName[1] = 'LinkedContacts';
                    } else if (layoutTabName[1].toString() === 'Campaigns stealth') {
                        layoutTabName[1] = 'ContactCampaignsStealth';
                        this.$root.$emit('DISABLE_SAVE_BUTTON', false);
                    } else if (layoutTabName[1].toString() === 'Referral partner') {
                        this.$root.$emit('DISABLE_SAVE_BUTTON', false);
                        layoutTabName[1] = 'ContactReferralPartner';
                    } else if (layoutTabName[1].toString() === 'Access privileges') {
                        this.$root.$emit('DISABLE_SAVE_BUTTON', false);
                        layoutTabName[1] = 'ContactAccessPrivileges';
                    } else if (layoutTabName[1].toString() === 'Campaigns') {
                        this.$root.$emit('DISABLE_SAVE_BUTTON', false);
                        layoutTabName[1] = 'ContactCampaigns';
                    } else if (layoutTabName[1].toString() === 'Follow-up sequences') {
                        this.$root.$emit('DISABLE_SAVE_BUTTON', false);
                        layoutTabName[1] = 'ContactFollowUpSequences';
                    } else if (layoutTabName[1].toString() === 'Web profile') {
                        this.$root.$emit('DISABLE_SAVE_BUTTON', false);
                        layoutTabName[1] = 'ContactWebProfile';
                    } else {
                        this.$root.$emit('DISABLE_SAVE_BUTTON', false);
                        layoutTabName[1] = layoutTabName[1].toString();
                    }
                    this.tabName = layoutTabName[1].toString();
                    tab = layoutTabName[1].toString();

                    if (this.tabComponentName.has(layoutTabName[1])) {
                        tab = layoutTabName[1].toString();
                    } else if (layoutTabName[1] === 'Custom fields') {
                        this.$root.$emit('DISABLE_SAVE_BUTTON', true);
                        tab = 'ContactInfo';
                    } else {
                        tab = 'ContactTabUnderConstruction';
                    }
                } else {
                    this.$root.$emit('DISABLE_SAVE_BUTTON', true);
                    tab = 'ContactInfo';
                }
            } else {
                tab = 'ContactTabUnderConstruction';
            }

            return tab;
        },

        async fetchDropdowns() {
            try {
                const response = await axios.get(`${this.url}/loadDropdowns`, {
                    headers: {
                        Accept: 'application/json',
                    },
                });

                this.options = response.data;
                this.buildDropdowns();
                this.$root.$emit('DROPDOWN_LOADED', this.options);
            } catch (e) {
                this.$error({ message: 'Unable to load all dropdowns' });
            }
        },

        async getContactPermissions() {
            const url = `/app/contactPermission/loadContactPermissions/${this.contact.id}`;

            try {
                const response = await axios.get(url, {
                    headers: {
                        Accept: 'application/json',
                    },
                });

                this.contactPermissionDTO = response.data;
                this.$root.$emit('CONTACTPERMISSIONS', this.contactPermissionDTO);
            } catch (error) {
                this.$error({ message: 'error while loading Contact Permisssions' });
            }
        },

        buildDropdowns() {
            const personType = [{ label: 'None', value: '' }];

            this.options.personType = Object.keys(this.options.personType).map((key) => {
                personType.push({ label: key, value: key });

                return { label: key, value: key };
            });
            this.options.personType = personType;

            const ownersDrop = [{ label: 'None', value: 0 }];

            this.options.owners = Object.entries(this.options.owners).map((key) => {
                ownersDrop.push({ label: key[1], value: Number(key[0]) });

                return { label: key[1], value: Number(key[0]) };
            });
            this.options.owners = ownersDrop;

            const countryDrop = [{ label: 'None', value: '' }];

            this.options.country = Object.keys(this.options.country).map((key) => {
                countryDrop.push({ label: this.options.country[key], value: key });

                return { label: this.options.country[key], value: key };
            });
            this.options.country = countryDrop;

            const phoneTypeDrop = this.options.phoneTypes;
            const phoneTypesList = [{ label: 'None', value: '' }];

            this.options.phoneTypes = Object.keys(phoneTypeDrop).map((key) => {
                phoneTypesList.push({ label: key, value: phoneTypeDrop[key] });

                return { label: key, value: phoneTypeDrop[key] };
            });
            this.options.phoneTypes = phoneTypesList;

            const languageDropList = [{ label: 'None', value: '' }];
            const languageDrop = this.options.languages;

            this.options.languages = Object.keys(this.options.languages).map((key) => {
                delete languageDrop['&mdash;'];
                languageDropList.push({ label: languageDrop[key], value: key });

                return { label: languageDrop[key], value: key };
            });
            this.options.languages = languageDropList;

            const timeZonesList = [{ label: 'None', value: '' }];

            this.options.timeZones = Object.keys(this.options.timeZones).map((key) => {
                timeZonesList.push({ label: this.options.timeZones[key], value: key });

                return { label: this.options.timeZones[key], value: key };
            });
            this.options.timeZones = timeZonesList;

            const suffixesList = [{ label: 'None', value: '' }];
            const suffixesDrop = this.options.suffixs;

            this.options.suffixs = Object.keys(this.options.suffixs).map((key) => {
                suffixesList.push({ label: key, value: suffixesDrop[key] });

                return { label: key, value: suffixesDrop[key] };
            });
            this.options.suffixs = suffixesList;


            const titlesList = [{ label: 'None', value: '' }];
            const titlesDrop = this.options.titles;


            this.options.titles = Object.keys(titlesDrop).map((key) => {
                titlesList.push({ label: key, value: titlesDrop[key] });

                return { label: key, value: titlesDrop[key] };
            });
            this.options.titles = titlesList;

            const leadSourcesDrop = this.options.leadSources;

            this.options.leadSources = Object.keys(leadSourcesDrop).map((key) => {
                return { label: leadSourcesDrop[key], value: Number(key) };
            });
        },
    },
};
</script>

<style lang="scss">
.main-section {
    flex-flow: row wrap;
    .multiselect .search-input {
        padding: 0 $spacing-200;
        font-size: $font-size-sm;
    }

    .select-container label,
    .date-picker-container label {
        padding: 0 0.6rem 0 0;
        font-size: $font-size-sm;
    }

    .input-field input:focus ~ label,
    .input-field input:active ~ label,
    .date-picker.active label,
    .date-picker.has-selected label,
    .select-field.has-selected label,
    .input-field input.dirty:valid ~ label,
    .input-field textarea:focus ~ label,
    .input-field textarea.dirty:valid ~ label,
    .multiselect-tags > span.input-span > label.static-label,
    .multiselect.active .input-container label, .select-field.active label,
    .multiselect-tags > span.input-span > label.pill-label,
    .multiselect.active .input-container .pill-label {
        font-size: $font-size-xs;
    }

    .multiselect-tags > span.input-span > label,
    .input-field input, .select-input input,
    .input-field > label,
    .input-field textarea,
    .date-picker-container input {
        font-size: $font-size-sm;
    }

    .custom-fields-container .input-field .trailing button {
        padding-top: 0;
    }

    .select-field.has-selected label,
    .date-picker.active label,
    .date-picker.has-selected label {
        padding: 0 $spacing-050;
    }

    .multiselect.active .input-container .showSearchIcon .search-input {
        padding: 0;
    }

    .input-field textarea {
        padding: 0.85rem;
    }
}

.main-div {
    flex-direction: column;
}

.hidden-tab > div.tab-header {
    display: none;
}
</style>
